import type { Shift } from '../api/generated/Shift'

export type Fill = { accepted: number; required: number }

export type FillState = 'full' | 'partial' | 'empty'

/** Extra volunteers on a shift do not make up for missing ones on another. */
export function fillOf(shifts: Shift[]): Fill {
  let accepted = 0
  let required = 0
  for (const shift of shifts) {
    accepted += Math.min(shift.accepted_volunteers, shift.required_volunteers)
    required += shift.required_volunteers
  }
  return { accepted, required }
}

export function fillState(fill: Fill): FillState {
  if (fill.accepted >= fill.required) return 'full'
  return fill.accepted > 0 ? 'partial' : 'empty'
}

/** Orders shifts by start time, as the API does. */
export function sortShifts(shifts: Shift[]): Shift[] {
  return [...shifts].sort(
    (a, b) => a.starts_at.localeCompare(b.starts_at) || a.id.localeCompare(b.id),
  )
}
